import { render, staticRenderFns } from "./OrderItemMealDealSections.vue?vue&type=template&id=3bee57f2"
import script from "./OrderItemMealDealSections.vue?vue&type=script&lang=js"
export * from "./OrderItemMealDealSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports